import React from "react"
import styled from "styled-components"
import media from "./../utils/media"
import vars from "./../utils/variables"

const Container = styled.div`
  display: flex;
  width: 100%;
  position: relative;
  padding: 0 1.25rem;
  margin: 0 auto;
  max-width: ${vars.containerWidth};
  flex-wrap: wrap;
  ${media.desktop`
    padding: 0 4rem;
  `};
`

export default ({ className, children }) => (
  <Container className={className}>{children}</Container>
)



// WEBPACK FOOTER //
// ./src/components/container.js